<app-grid-container class="single-plan-sale">
  <app-grid-row class="white-container">
    <app-grid-column>
      <app-grid-row>
        <app-grid-column>
          <app-progression-steps />

          <h1 class="single-plan-sale__title">
            What your guarantee covers - and what it doesn't
          </h1>

          <div class="single-plan-sale__trustpilot">
            <app-trustbox />
          </div>

          <p class="single-plan-sale__subtitle">
            Your manufacturer guarantee covers repairs for manufacturing faults
            for {{ warrantyInMonths() }} months. Appliance Care provides
            additional cover beyond your guarantee, including accidental damage.
          </p>

          @if (hasFreeMonths()) {
            <div class="single-plan-sale__2mf-promotional-banner mb-4">
              <app-icon
                [name]="'gift'"
                [size]="'md'"
                aria-hidden="true"
                class="single-plan-sale__2mf-promotional-banner__icon"
              />
              <h5 class="single-plan-sale__2mf-promotional-banner__title">
                Start your cover today. Pay nothing for 60 days*. Cancel
                anytime.
              </h5>
            </div>
          }

          <div
            aria-label="Cover comparison"
            class="single-plan-simple-table"
            role="table"
          >
            <div class="single-plan-simple-table__title" role="row">
              <h4>Cover comparison</h4>
            </div>
            <div class="single-plan-simple-table__headers" role="row">
              <p role="columnheader">What you get</p>
              <p role="columnheader">Standard guarantee</p>
              <p
                class="single-plan-simple-table__headers-ac"
                role="columnheader"
              >
                Appliance Care
              </p>
            </div>
            <div class="single-plan-simple-table__row" role="row">
              <p>Accidental damage included</p>
              <span
                ><app-icon [family]="'light'" [name]="'circle-xmark'"
              /></span>
              <span class="single-plan-simple-table__included"
                ><app-icon [family]="'solid'" [name]="'circle-check'"
              /></span>
            </div>
            <div class="single-plan-simple-table__row" role="row">
              <p>Unlimited repairs</p>
              <span
                ><app-icon [family]="'light'" [name]="'circle-xmark'"
              /></span>
              <span class="single-plan-simple-table__included"
                ><app-icon [family]="'solid'" [name]="'circle-check'"
              /></span>
            </div>
            <div class="single-plan-simple-table__row" role="row">
              <p>
                Replacement with same or similar features, if it can't be fixed
              </p>
              <span
                ><app-icon [family]="'light'" [name]="'circle-xmark'"
              /></span>
              <span class="single-plan-simple-table__included"
                ><app-icon [family]="'solid'" [name]="'circle-check'"
              /></span>
            </div>
          </div>

          <div
            class="single-plan-sale__exclusion-panel single-plan-sale__ab-limitations"
          >
            <h4 class="single-plan-sale__exclusion-panel-title">
              Key limitations to be aware of
            </h4>
            <div class="single-plan-sale__exclusion-panel-container">
              <section>
                <app-icon [family]="'light'" [name]="'circle-xmark'" />
                <p>
                  Cosmetic damage, such as scratches or dents, isn't covered
                </p>
              </section>
              <section>
                <app-icon [family]="'light'" [name]="'circle-xmark'" />
                <p>Deliberate damage isn't covered</p>
              </section>
              <section>
                <app-icon [family]="'light'" [name]="'circle-xmark'" />
                <p>Installation or removal costs aren't included</p>
              </section>
            </div>
            <app-terms-and-conditions-panel
              [noPadding]="true"
              [toggleIcon]="false"
              [transparent]="true"
              class="single-plan-sale__exclusion-panel-terms-and-conditions"
            />
          </div>

          <section class="single-plan-sale-footer single-plan-sale-footer--ab">
            @if (hasPromo()) {
              <div class="single-plan-sale-footer__promo-details">
                <app-single-plan-promo-price
                  [titlePriceVariant]="TitlePriceVariant.Heading2"
                />
                <p class="single-plan-sale-footer__cancel-anytime my-2">
                  {{
                    "PROTECTION_DETAILS_APPLIANCE_CARE_BENEFITS_CANCEL_ANYTIME_ALT"
                      | translate
                  }}
                </p>
                <p class="single-plan-sale-footer__cancel-anytime my-2">
                  {{
                    "PROTECTION_DETAILS_APPLIANCE_CARE_BENEFITS_CANCEL_ANYTIME"
                      | translate
                  }}
                </p>
                @if (applianceInGuarantee()) {
                  <p class="single-plan-sale-footer__disclaimer">
                    {{
                      "PROTECTION_DETAILS_APPLIANCE_CARE_BENEFITS_POLICY_DISCLAIMER"
                        | translate
                    }}
                  </p>
                }
              </div>
            } @else if (isOneOffPayment()) {
              <div class="single-plan-sale-footer__price-context">
                {{
                  "SINGLE_PLAN_SALE_PAGE_FOOTER_TITLE_PRICE_ONE_OFF"
                    | translate
                      : {
                          price:
                            selectedQuotePaymentOption.fee | currencyFormat,
                        }
                }}
              </div>
            } @else if (hasFreeMonths()) {
              <div class="single-plan-sale-footer__price-context">
                First 2 months free, then
                {{
                  selectedQuotePaymentOption.subsequentPayment | currencyFormat
                }}
                a month
              </div>
            } @else {
              <div class="single-plan-sale-footer__price-context">
                {{
                  "SINGLE_PLAN_SALE_PAGE_FOOTER_TITLE_PRICE"
                    | translate
                      : {
                          price:
                            selectedQuotePaymentOption.subsequentPayment
                            | currencyFormat,
                        }
                }}
              </div>
              <p class="single-plan-sale-footer__subtitle">
                {{ "SINGLE_PLAN_SALE_PAGE_FOOTER_SUBTITLE" | translate }}
              </p>
            }

            <div
              class="single-plan-sale-footer__buttons single-plan-sale-footer__buttons--ab"
            >
              <app-grid-row>
                <app-grid-column [md]="6">
                  <app-button
                    (click)="purchasePlanClicked()"
                    [fill]="true"
                    [variant]="'success'"
                    class="single-plan-sale-footer__button--purchase-plan"
                  >
                    @if (isOneOffPayment()) {
                      Yes - add Appliance Care (one-off
                      {{ selectedQuotePaymentOption.fee | currencyFormat }})
                    } @else if (hasFreeMonths()) {
                      Yes - add Appliance Care (first 2 months free, then
                      {{
                        selectedQuotePaymentOption.subsequentPayment
                          | currencyFormat
                      }}/month)
                    } @else {
                      Yes - add Appliance Care ({{
                        selectedQuotePaymentOption.subsequentPayment
                          | currencyFormat
                      }}/month)
                    }
                  </app-button>
                </app-grid-column>
                <app-grid-column [md]="6">
                  <app-button
                    (click)="registerOnlyClicked()"
                    [fill]="true"
                    [variant]="'neutral-alternative'"
                    class="single-plan-sale-footer__button--register-only"
                  >
                    No thanks - continue with registration only
                  </app-button>
                </app-grid-column>
              </app-grid-row>
            </div>

            <div class="single-plan-sale__ab-trustpilot-wrap">
              <div class="single-plan-sale__footer-trustpilot">
                <app-trustbox />
              </div>
            </div>

            <p class="single-plan-sale__provided-by">
              {{ "SINGLE_PLAN_SALE_PAGE_PROVIDED_BY" | translate }}
              <img
                [src]="`assets/dg.svg`"
                alt="DNG Logo"
                class="single-plan-sale__provided-by-logo"
              />
            </p>
          </section>
        </app-grid-column>
      </app-grid-row>
    </app-grid-column>
  </app-grid-row>
</app-grid-container>
